import {FormControlLabel, Radio, RadioGroup} from '@material-ui/core';
import React, {useState, useEffect} from 'react';

const Singlebox = ({data, setCorrect}) => {
  const [checked, setChecked] = useState(-1);
  const evaluateSingle = (ix, answer) => {
    setChecked(ix);
    setCorrect(answer.correctAnswer);
  };

  useEffect(() => {
    setChecked(-1);
  }, [data]);

  return (
    <RadioGroup value={data.iD_Answer} style={{paddingLeft: '10%'}}>
      {data.answers.map((answer, ix) => {
        return (
          <FormControlLabel
            style={{paddingBottom: '30px', textAlign: 'initial'}}
            value={answer.iD_Answer}
            key={answer.iD_Answer}
            control={
              <Radio
                checked={checked === ix}
                onChange={() => {
                  evaluateSingle(ix, answer);
                }}
                value={data.iD_Answer}
              />
            }
            label={answer.text_Answer}
          />
        );
      })}
    </RadioGroup>
  );
};

export default Singlebox;
